import React, { useState } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import WhyChoose from "./components/WhyChoose";
import About from "./components/About";
import Footer from "./components/Footer";
import Professions from "./components/Professions";
import NurseApplyModal from "./components/NurseApplyModal";
import DoctorApplyModal from "./components/DoctorApplyModal";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import NurseAppointment from "./pages/NurseAppointment";
import DoctorAppointment from "./pages/DoctorAppointment";
import "./App.css";
import DoctorsList from "./pages/DoctorsList";
import NursesList from "./pages/NursesList";
import Appointment from "./pages/Appointment";
import HospitalsList from "./pages/HospitalsList";
import VerifyUser from "./components/VerifyUser";
import HospitalDoctors from "./pages/HospitalDoctors";
import AppointmentHistory from "./pages/AppointmentHistory";
import Help from "./pages/Help";
import PharmaciesList from "./pages/PharmaciesList";
import PharmacyProducts from "./pages/PharmacyProducts";
import DriverBooking from "./pages/DriverBooking";
function App() {
  const [isNurseApplyModalOpen, setIsNurseApplyModalOpen] = useState(false);
  const [isDoctorApplyModalOpen, setIsDoctorApplyModalOpen] = useState(false);

  const handleApplyNurseClick = () => setIsNurseApplyModalOpen(true);
  const handleApplyDoctorClick = () => setIsDoctorApplyModalOpen(true);

  return (
    <BrowserRouter>
      <div className="App">
        <ToastContainer position="top-center" autoClose={4000} hideProgressBar={false} theme="light" />
        <AppContent
          onApplyNurseClick={handleApplyNurseClick}
          onApplyDoctorClick={handleApplyDoctorClick}
        />

        {/* Modals */}
        <NurseApplyModal
          isOpen={isNurseApplyModalOpen}
          onClose={() => setIsNurseApplyModalOpen(false)}
        />

        <DoctorApplyModal
          isOpen={isDoctorApplyModalOpen}
          onClose={() => setIsDoctorApplyModalOpen(false)}
        />
      </div>
    </BrowserRouter>
  );
}

function AppContent({ onApplyNurseClick, onApplyDoctorClick }) {
  const navigate = useNavigate();

  const handleAppointmentClick = () => {
    navigate("/hospitals");
  };

  const handleNurseAppointmentClick = () => {
    navigate("/nurses-list");
  };

  const handleVideoConsultingClick = () => {
    navigate("/doctors");
  };

  return (
    <>
      <Header
        onAppointmentClick={handleAppointmentClick}
        onNurseAppointmentClick={handleNurseAppointmentClick}
        onVideoConsultingClick={handleVideoConsultingClick}
        onApplyNurseClick={onApplyNurseClick}
        onApplyDoctorClick={onApplyDoctorClick}
      />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero
                onAppointmentClick={handleAppointmentClick}
                onNurseAppointmentClick={handleNurseAppointmentClick}
              />
              {/* <DoctorsList />
              <NursesList />
              <HospitalsList /> */}
              <WhyChoose />
              <About />
              <Professions />
            </>
          }
        />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verify" element={<VerifyUser />} />
        <Route path="/appointment" element={<Appointment />} />
        <Route path="/hospitals" element={<HospitalsList />} />
        <Route path="/doctor-appointment" element={<DoctorAppointment />} />
        <Route path="/nurses-list" element={<NursesList />} />
        <Route path="/nurse-appointment" element={<NurseAppointment />} />
        <Route path="/doctors" element={<DoctorsList />} />
        <Route path="/hospital/:hospitalId/doctors" element={<HospitalDoctors />} />
        <Route path="/appointments/history" element={<AppointmentHistory />} />
        <Route path="/help" element={<Help />} />
        <Route path="/pharmacies" element={<PharmaciesList />} />
        <Route path="/pharmacy/:pharmacyId" element={<PharmacyProducts />} />
        <Route path="/driver-booking" element={<DriverBooking />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;